import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { updateProfile } from '../../services/users';
import Input from '../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import Toast from '../../components/Common/Toast';

const Profile = () => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const { control, handleSubmit } = useForm({ defaultValues: user });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await updateProfile(data);
      setToast({ type: 'success', message: 'Profile updated' });
      // Optionally refresh user state
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>My Profile</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input name="full_name" control={control} label="Full Name" />
        <Input name="email" control={control} label="Email" />
        <Input name="phone" control={control} label="Phone" />
        <button type="submit" disabled={loading}>Update</button>
        <button type="button" onClick={logout}>Logout</button>
      </form>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default Profile;